import React, { useState } from 'react';
import NoAnswers from "../NoAnswers"
import { useTheme } from '@material-ui/styles';
import { Icon } from '@material-ui/core';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import ByWeek from './ByWeek'
import ByMonth from './ByMonth'

//#region MatrixChartColors
// function mapCountToColor(count, maxCount) {
//     const r = scale(count, 0, maxCount, 225, 93)
//     const g = scale(count, 0, maxCount, 235, 154)
//     const b = scale(count, 0, maxCount, 230, 157)
//     return `rgb(${r}, ${g}, ${b})`
// }
// const scale = (num, in_min, in_max, out_min, out_max) => {
//     return (num - in_min) * (out_max - out_min) / (in_max - in_min) + out_min;
// }
//#endregion

export default function DateTimeCharts(props) {
    const { analytics } = props

    const [zoomIn, setZoomIn] = useState("zoomout");
    const theme = useTheme();

    if (analytics.answerCount === 0) {
        return <NoAnswers text="No dates given yet" />
    }

    return <div style={{ marginTop: '-2em' }}>
        <div style={{ display: 'flex', justifyContent: 'center', transform: 'scale(.85)', marginBottom: '3em', color: theme.palette.primary.main, fontSize: '0.8em' }}>
            <ToggleButtonGroup
                size="small"
                value={zoomIn}
                exclusive
                onChange={(e, v) => { 
                    e.stopPropagation()
                    v && setZoomIn(v)
                }}
                aria-label="zoom"
            >
                <ToggleButton value="zoomin" aria-label="zoomin">
                    <Icon>zoom_in</Icon>
                </ToggleButton>
                <ToggleButton value="zoomout" aria-label="zoomout">
                    <Icon>zoom_out</Icon>
                </ToggleButton>
            </ToggleButtonGroup>
        </div>

        <div style={{ marginTop: '-2em', height: '12em' }}>
            {zoomIn === "zoomin" && <ByWeek {...props} />}
            {zoomIn === "zoomout" && <ByMonth {...props} />}
        </div>
    </div>
}